var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c("validation-observer", { ref: "amendmentForm" }, [
          _c("div", { staticClass: "row py-4 px-5" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("label", { staticClass: "font-18 font-weight-bold" }, [
                _c("i", { staticClass: "fas fa-comment text-orange mr-1" }),
                _vm._v(" Enmendar ")
              ])
            ]),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            attrs: {
                              "custom-error-msg": "El comentario es requerido.",
                              error: errors[0],
                              label: "Comentario:",
                              maxlength: 3000,
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.model.comment,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "comment", $$v)
                              },
                              expression: "model.comment"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-12 d-flex justify-content-end align-items-center"
              },
              [
                _c("action-button", {
                  attrs: {
                    i: "fas fa-times-circle",
                    text: "Cancelar",
                    variant: "outline-danger mr-3 px-3"
                  },
                  on: { click: _vm.cancel }
                }),
                _c("action-button", {
                  attrs: {
                    i: "fas fa-save",
                    text: "Guardar",
                    variant: "success px-3"
                  },
                  on: { click: _vm.save }
                })
              ],
              1
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }